import { render } from "./EntryDescr.vue?vue&type=template&id=69cce44c&scoped=true"
import script from "./EntryDescr.vue?vue&type=script&lang=js"
export * from "./EntryDescr.vue?vue&type=script&lang=js"

import "./EntryDescr.vue?vue&type=style&index=0&id=69cce44c&scoped=true&lang=css"

import exportComponent from "C:\\PRO\\TimeSheet\\vue-cal-dev-ts-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69cce44c"]])

export default __exports__